// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUploadOutlinedSvg from "@fishx/icons-svg/es/asn/PUploadOutlined";
import FishxIcon from '../components/FishxIcon';

var PUploadOutlined = function PUploadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUploadOutlinedSvg
  }));
};

PUploadOutlined.displayName = 'PUploadOutlined';
export default React.forwardRef(PUploadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUploadOutlined.js
// module id = 3709
// module chunks = 0